var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-background",style:({background: _vm.background})},[_c('i',{class:`fa-regular ${_vm.icon}`,style:({color: _vm.iconColor})})])
}
var staticRenderFns = []

export { render, staticRenderFns }